/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const verifyUserAttributePostRequestSchema = z.object({
  attribute_name: z.string(),
  code: z.string(),
});
